import script from "./LogAlma.vue?vue&type=script&lang=ts&setup=true"
export * from "./LogAlma.vue?vue&type=script&lang=ts&setup=true"

import "./LogAlma.vue?vue&type=style&index=0&id=a8fff0a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8fff0a6"]])

export default __exports__